import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch intercompany segments filtered by chart of accounts fields.
 * @param {string} division - The division code to filter by.
 * @param {string} location - The location code to filter by.
 * @param {string} costCenter - The cost center code to filter by.
 * @param {string} account - The account code to filter by.
 * @returns {object} Segments query result with data, loading, success, and error states.
 */
export const useSegments = (division, location, costCenter, account) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_SEGMENTS, division, location, costCenter, account],
    queryFn: () => api.invMgmt.getSegments({ division, location, costCenter, account }),
    enabled: apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter) && Boolean(account),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    segments: data,
    segmentsIsLoading: isLoading,
    segmentsIsSuccess: isSuccess,
    segmentsIsError: isError,
    segmentsError: error,
  };
};
